import * as React from "react";
import { Link } from "react-router-dom";
import { Util } from "../../util/Util";

export const FullFolder = (props: { content: any }) => {
  return <div></div>;
};
